// extracted by css-extract-rspack-plugin
export default {"body":"body-SRrJJH","linkField":"linkField-St0pzy","linkAction":"linkAction-vMowRI"};